import { Box, Sheet, Typography } from "@mui/joy";
import { TaskEditorDescriptionComponent } from "pages/task-editor/utils/taskEditorUtils";
import { theme } from "styles/theme";

// 미리보기에서 reference_automatic_thought 에 표시할 샘플 텍스트
export const PREVIEW_SAMPLE_AUTOMATIC_THOUGHT = "나는 이 일을 망칠 것 같아.";

interface PreviewDescriptionProps {
  component: TaskEditorDescriptionComponent;
}

function PreviewDescription({ component }: PreviewDescriptionProps) {
  switch (component.type) {
    case "text": {
      const content = component.content || "(텍스트 없음)";
      const isEmpty = !component.content;

      if (component.typography_style === "header") {
        return (
          <Typography
            variant="H3"
            sx={{
              color: isEmpty
                ? theme.vars.palette.Content.Weak
                : theme.vars.palette.Content.Strong,
              fontWeight: 700,
              wordBreak: "keep-all",
            }}
          >
            {content}
          </Typography>
        );
      }

      if (component.typography_style === "label") {
        return (
          <Typography
            variant="Caption"
            sx={{
              color: isEmpty
                ? theme.vars.palette.Content.Weak
                : theme.vars.palette.Content.Highlight,
              fontWeight: 700,
            }}
          >
            {content}
          </Typography>
        );
      }

      // body — v1 TypographyCell 의 body 는 wordBreak 미지정(브라우저 기본 normal)
      // 이라 한글이 글자 단위로 줄을 꽉 채워 줄바꿈된다. 프리뷰도 동일하게 맞춘다
      // (keep-all 미적용). header 만 keep-all 로 단어 끊김을 막는다.
      return (
        <Typography
          variant="Body"
          sx={{
            color: isEmpty
              ? theme.vars.palette.Content.Weak
              : theme.vars.palette.Content.Strong,
            fontWeight: 500,
            whiteSpace: "pre-wrap",
            // 본문 행간을 테마 Body(132%)보다 넓혀 가독성↑ (미리보기 한정).
            lineHeight: 1.5,
          }}
        >
          {content}
        </Typography>
      );
    }

    case "image": {
      if (!component.content) {
        return (
          <Sheet
            sx={{
              border: "1px dashed",
              borderColor: theme.vars.palette.Border.Weak,
              backgroundColor: theme.vars.palette.Background.Level1,
              borderRadius: "6px",
              p: "16px",
              textAlign: "center",
            }}
          >
            <Typography
              variant="Caption"
              sx={{ color: theme.vars.palette.Content.Weak }}
            >
              (이미지 없음)
            </Typography>
          </Sheet>
        );
      }
      return (
        <Box
          component="img"
          src={component.content}
          alt=""
          sx={{ width: "100%", borderRadius: "6px", display: "block" }}
        />
      );
    }

    case "reference_automatic_thought": {
      return (
        <Typography
          variant="Body"
          sx={{
            color: theme.vars.palette.Content.Strong,
            fontWeight: 500,
            whiteSpace: "pre-wrap",
            lineHeight: 1.5,
          }}
        >
          {PREVIEW_SAMPLE_AUTOMATIC_THOUGHT}
        </Typography>
      );
    }

    case "reference_coach_preset": {
      const text = component.preset_text;
      if (!text) {
        return (
          <Typography
            variant="Body"
            sx={{ color: theme.vars.palette.Content.Weak, fontWeight: 500 }}
          >
            (코치 프리셋 비어있음)
          </Typography>
        );
      }
      return (
        <Typography
          variant="Body"
          sx={{
            color: theme.vars.palette.Content.Strong,
            fontWeight: 500,
            whiteSpace: "pre-wrap",
            lineHeight: 1.5,
          }}
        >
          {text}
        </Typography>
      );
    }

    default: {
      const _never: never = component;
      void _never;
      return null;
    }
  }
}

export default PreviewDescription;
